import React from 'react';
import TextField from 'components/form-components/TextField';
import searchIcon from 'assets/images/icons/search.svg';
import PropTypes from 'prop-types';
import FormButton from 'components/form-components/FormButton';
import plusIcon from 'assets/images/icons/plus.svg';
import { isPermissionAvailable } from 'config/permissionUtils';
import { permissionKeys } from 'config/config';

const TopicsSetsListHeaders = ({
  filteringData,
  setFilteringData,
  debounceFunc,
  handleAddTopicSet,
}) => {
  return (
    <div className='section-header d-flex justify-content-between align-items-center px-2'>
      <div className='d-flex gap-3'>
        <TextField
          value={filteringData['search'] ? filteringData['search'] : ''}
          name='search'
          handleChange={setFilteringData}
          placeholder='field_search'
          icon={searchIcon}
          debounceFunc={debounceFunc}
          shrink
        />
      </div>
      {isPermissionAvailable(permissionKeys.field_work_response_set_create) && (
        <FormButton
          text='button_add_new'
          variant='green-1'
          onClick={handleAddTopicSet}
          icon={plusIcon}
          iconClasses='svg-white'
        />
      )}
    </div>
  );
};

TopicsSetsListHeaders.propTypes = {
  filteringData: PropTypes.object.isRequired,
  setFilteringData: PropTypes.func.isRequired,
  debounceFunc: PropTypes.func.isRequired,
  handleAddTopicSet: PropTypes.func.isRequired,
};

export default TopicsSetsListHeaders;
